import styled from 'react-emotion';
import {
  space,
  width,
  // fontSize,
  color,
  textAlign,
  justifyContent,
  responsiveStyle
} from 'styled-system';

const wrap = responsiveStyle({
  prop: 'wrap',
  cssProperty: 'flexWrap'
});

export const Box = styled.div`
  overflow: hidden;
  background-color: white;
  ${space} ${width} ${color} ${textAlign};
`;

export const BoxClear = styled.div`
  overflow: hidden;
  clear: both
  background-color: white;
  ${space} ${width} ${color} ${textAlign};
`;

export const BoxLeft = styled.div`
  overflow: visible;
  float: left;
  width: 45%;
  ${space} ${width} ${color} ${textAlign};
`;

export const BoxRight = styled.div`
  overflow: visible;
  float: right;
  background-color: white;
  width: 50%;
  ${space} ${width} ${color} ${textAlign};
`;

export const BoxRightFixed = styled.div`
  overflow: visible;
  float: right;
  position: fixed;
  width: 35%;
  ${space} ${width} ${color} ${textAlign};
`;

export const BoxRightSmall = styled.div`
  overflow: visible;
  float: right;
  width: 25%;
  ${space} ${width} ${color} ${textAlign};
`;

// ${space} ${width} ${fontSize} ${color} ${textAlign};
export const Flex = styled.div`
  display: flex;
  ${justifyContent} ${wrap};
`;



// WEBPACK FOOTER //
// ./src/components/Layout/index.js